export const KPI_CARDS = [
  {
    label: "Total Travelers",
    key: "totalTravelers",
    icon: "fas fa-users",
    iconClass: "text-primary",
    bgColor: "rgba(94, 114, 228, 0.1)",
    trend: "Total",
    trendClass: "text-primary",
    route: "/admin/users-list",
    valueClass: "kpi-value",
  },

  {
    label: "Total Guides",
    key: "totalGuides",
    icon: "fas fa-user-tie",
    iconClass: "text-success",
    bgColor: "rgba(45, 206, 137, 0.1)",
    trend: "Total",
    trendClass: "text-success",
    route: "/admin/guide-management",
    valueClass: "kpi-value",
  },

  {
    label: "Pending Verification",
    key: "pendingVerification",
    icon: "fas fa-user-check",
    iconClass: "text-warning",
    bgColor: "rgba(251, 99, 64, 0.1)",
    trend: "Pending",
    trendClass: "text-warning",
    route: "/admin/verification-management",
    state: { statusFilter: "pending" },
    valueClass: "kpi-value",
  },

  {
    label: "Total Bookings",
    key: "totalBookings",
    icon: "fas fa-calendar-check",
    iconClass: "text-info",
    bgColor: "rgba(17, 205, 239, 0.1)",
    trend: "All Time",
    trendClass: "text-info",
    route: "/admin/guide-bookings",
    valueClass: "kpi-value",
  },

  // {
  //   label: "Upcoming Tours",
  //   key: "upcomingTours",
  //   icon: "fas fa-route",
  //   iconClass: "text-danger",
  //   bgColor: "rgba(245, 54, 92, 0.1)",
  //   trend: "Upcoming",
  //   trendClass: "text-danger",
  //   route: "/admin/bookings",
  //   valueClass: "kpi-value",
  // },

  // {
  //   label: "Completed Tours",
  //   key: "completedTours",
  //   icon: "fas fa-check-circle",
  //   iconClass: "text-success",
  //   bgColor: "rgba(45, 206, 137, 0.1)",
  //   trend: "Completed",
  //   trendClass: "text-success",
  //   route: "/admin/bookings",
  //   valueClass: "kpi-value",
  // },

  // {
  //   label: "Subscription Revenue",
  //   key: "subscriptionRevenue",
  //   icon: "fas fa-dollar-sign",
  //   iconClass: "text-primary",
  //   bgColor: "rgba(94, 114, 228, 0.1)",
  //   trend: "Revenue",
  //   trendClass: "text-primary",
  //   route: "/admin/payments",
  //   valueClass: "kpi-value",
  // },

  // {
  //   label: "Average Rating",
  //   key: "averageRating",
  //   icon: "fas fa-star",
  //   iconClass: "text-warning",
  //   bgColor: "rgba(251, 99, 64, 0.1)",
  //   trend: "Rating",
  //   trendClass: "text-warning",
  //   route: "/admin/reviews",
  //   valueClass: "kpi-value",
  // },
];
